"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import { FolderComponent } from "./FolderComponent/FolderComponent";
import { Folder, OptionsVertical } from "../../icons";
import TextInput, { TextInputSize } from "../TextInput/TextInput";
import { OptionMenu, OptionMenuItem } from "../OptionMenu";
import IconButton from "../IconButton/IconButton";
import { ButtonSize } from "../Button/Button";
import { action, observable } from "mobx";
import { duration } from "../../../tokens/tokens-css";
import { Transition } from "react-transition-group";
import OptionMenuSeparator from "../OptionMenu/OptionMenuSeparator";
import * as styles from "./TreebeardHeader-css";
export let TreebeardHeader = class extends React.Component {
  constructor(props) {
    super(props);
    this.isRenaming = false;
    this.newName = null;
    this.isHovering = false;
    this.isFocused = false;
    this.startRenaming = () => {
      this.isRenaming = true;
    };
    this.createNewFolder = () => {
      var _a;
      if ((_a = this.props.node) == null ? void 0 : _a.onCreateFolder) {
        this.props.node.onCreateFolder(this.props.node.id);
      }
    };
    this.deleteFolder = () => {
      var _a;
      if ((_a = this.props.node) == null ? void 0 : _a.onDeleteFolder) {
        this.props.node.onDeleteFolder(this.props.node.id);
      }
    };
    this.setIsHovering = (newValue) => {
      this.isHovering = newValue;
    };
    this.setIsFocused = (newValue) => {
      this.isFocused = newValue;
    };
    this.renameConfirm = () => {
      if (this.isRenaming) {
        const { id, onRenameConfirm } = this.props.node;
        if (!!this.newName) {
          if (!!onRenameConfirm) {
            onRenameConfirm(id, this.newName);
          }
        } else {
          this.renameCancel();
        }
        this.resetRename();
      }
    };
    this.resetRename = () => {
      this.isRenaming = false;
      this.isHovering = false;
      this.isFocused = false;
      this.newName = null;
    };
    this.dragStartHandler = this.dragStartHandler.bind(this);
    this.dropHandler = this.dropHandler.bind(this);
    this.renameCancel = this.renameCancel.bind(this);
    this.renameConfirm = this.renameConfirm.bind(this);
    this.onChange = this.onChange.bind(this);
    this.keyPressed = this.keyPressed.bind(this);
    this.inputElement = React.createRef();
    this.isRenaming = props.node.renaming;
  }
  render() {
    const {
      className,
      selected,
      name,
      toggled,
      children,
      id,
      disableSelect,
      isBeingDragged,
      draggable,
      onDragEnd,
      disableOptions
    } = this.props.node;
    const hasSubfolders = children.length > 0;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        id: `tree-${id}-folder`,
        className: styles.folder,
        "aria-expanded": hasSubfolders ? toggled : void 0,
        draggable: draggable && !this.isRenaming,
        onDragStart: this.dragStartHandler,
        onDragEnd,
        onMouseEnter: () => this.setIsHovering(true),
        onMouseLeave: () => this.setIsHovering(false),
        onMouseOver: () => this.setIsHovering(true),
        onFocus: () => this.setIsFocused(true),
        onBlur: () => this.setIsFocused(false)
      },
      /* @__PURE__ */ React.createElement(
        FolderComponent,
        {
          hasMenuOption: !disableOptions,
          icon: /* @__PURE__ */ React.createElement(Folder, null),
          element: this.isRenaming ? "div" : "button",
          name,
          selected,
          onClick: this.isRenaming ? void 0 : () => {
            if (this.props.onSelect) {
              this.props.onSelect(this.props.node);
            }
          },
          onDrop: this.dropHandler,
          overrideNameComponent: this.isRenaming ? this.renderRenameInput() : void 0,
          endElement: !disableOptions && !this.isRenaming ? /* @__PURE__ */ React.createElement("div", { className: styles.menuSpacer }) : void 0,
          disableSelect,
          disableDrop: isBeingDragged
        }
      ),
      !disableOptions && /* @__PURE__ */ React.createElement(
        Transition,
        {
          mountOnEnter: true,
          unmountOnExit: true,
          in: !this.isRenaming && (this.isHovering || this.isFocused),
          timeout: duration.s
        },
        (status) => /* @__PURE__ */ React.createElement(
          OptionMenu,
          {
            className: `${className}__action-menu`,
            onClose: () => {
              this.isFocused = false;
            },
            size: "small",
            button: /* @__PURE__ */ React.createElement(
              IconButton,
              {
                "aria-label": "Folder options",
                className: styles.actions({ visible: ["entering", "entered"].includes(status) }),
                icon: /* @__PURE__ */ React.createElement(OptionsVertical, null),
                size: ButtonSize.Small
              }
            ),
            autoStack: false
          },
          /* @__PURE__ */ React.createElement(OptionMenuItem, { onClick: this.createNewFolder }, "New folder"),
          /* @__PURE__ */ React.createElement(OptionMenuItem, { onClick: this.startRenaming }, "Rename folder"),
          /* @__PURE__ */ React.createElement(OptionMenuSeparator, null),
          /* @__PURE__ */ React.createElement(OptionMenuItem, { onClick: this.deleteFolder, destructive: true }, "Delete folder")
        )
      )
    );
  }
  componentDidMount() {
    if (!!this.inputElement.current) {
      this.inputElement.current.focus();
    }
  }
  componentDidUpdate() {
    if (this.isRenaming) {
      setTimeout(() => {
        var _a, _b;
        (_b = (_a = this.inputElement) == null ? void 0 : _a.current) == null ? void 0 : _b.focus();
      }, 10);
    }
  }
  dragStartHandler(event) {
    const { onDragStart, id } = this.props.node;
    onDragStart(event, id);
  }
  dropHandler(event) {
    const { onDropOnFolder, id } = this.props.node;
    if (!!onDropOnFolder) {
      onDropOnFolder(event, id);
    }
  }
  renameCancel() {
    const { id, onRenameCancel } = this.props.node;
    if (!!onRenameCancel) {
      onRenameCancel(id);
    }
    this.resetRename();
  }
  keyPressed(event) {
    switch (event.key) {
      case "Enter":
        this.renameConfirm();
        break;
      case "Escape":
        this.renameCancel();
        break;
    }
  }
  onChange(value) {
    this.newName = value;
    const { id, onNameChange } = this.props.node;
    if (!!onNameChange) {
      onNameChange(id, this.newName);
    }
  }
  renderRenameInput() {
    const { name, maxNameLength } = this.props.node;
    if (this.newName === null) {
      this.newName = name;
    }
    return /* @__PURE__ */ React.createElement(
      TextInput,
      {
        labelHidden: true,
        ref: this.inputElement,
        className: styles.input,
        label: "Folder name",
        size: TextInputSize.Small,
        value: this.newName,
        onChange: this.onChange,
        onBlur: this.renameConfirm,
        onKeyDown: this.keyPressed,
        maxLength: maxNameLength,
        onClick: (e) => {
          e.stopPropagation();
        }
      }
    );
  }
};
__decorateClass([
  observable.ref
], TreebeardHeader.prototype, "isRenaming", 2);
__decorateClass([
  observable.ref
], TreebeardHeader.prototype, "newName", 2);
__decorateClass([
  observable.ref
], TreebeardHeader.prototype, "isHovering", 2);
__decorateClass([
  observable.ref
], TreebeardHeader.prototype, "isFocused", 2);
__decorateClass([
  action
], TreebeardHeader.prototype, "startRenaming", 2);
__decorateClass([
  action
], TreebeardHeader.prototype, "setIsHovering", 2);
__decorateClass([
  action
], TreebeardHeader.prototype, "setIsFocused", 2);
__decorateClass([
  action
], TreebeardHeader.prototype, "renameCancel", 1);
__decorateClass([
  action
], TreebeardHeader.prototype, "renameConfirm", 2);
__decorateClass([
  action
], TreebeardHeader.prototype, "resetRename", 2);
__decorateClass([
  action
], TreebeardHeader.prototype, "onChange", 1);
TreebeardHeader = __decorateClass([
  observer
], TreebeardHeader);
